<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h5 class="m-0">{{ lang.el('Traduzioni') }}</h5>
        <div class="flex gap-2 flex-wrap">
          <button pButton type="button" class="p-button-outlined"
            [label]="lang.el('Esporta vuote')"
            icon="pi pi-download"
            (click)="exportMissing()"
            [disabled]="loading"></button>
          <button pButton type="button" class="p-button-outlined"
            [label]="lang.el('Importa')"
            icon="pi pi-upload"
            (click)="openImportDialog()"></button>
          <button pButton type="button" class="p-button-outlined"
            [label]="lang.el('Popola glossario')"
            icon="pi pi-database"
            (click)="showPopulateDialog = true"></button>
        </div>
      </div>

      <p-dialog [(visible)]="showPopulateDialog"
        [header]="lang.el('Popola glossario')"
        [modal]="true" [style]="{ width: '32rem' }"
        [draggable]="false" [resizable]="false">
        <div class="grid">
          <div class="col-12">
            <label>{{ lang.el('Tabella origine') }}</label>
            <input pInputText class="w-full" [(ngModel)]="populateTable"
              placeholder="es. t_porte" />
          </div>
          <div class="col-12">
            <label>{{ lang.el('Campo descrizione') }}</label>
            <input pInputText class="w-full" [(ngModel)]="populateField"
              placeholder="des_comp" />
          </div>
        </div>
        <ng-template pTemplate="footer">
          <button pButton type="button" class="p-button-text"
            [label]="lang.el('Annulla')"
            (click)="showPopulateDialog = false"></button>
          <button pButton type="button"
            [label]="lang.el('Popola glossario')"
            icon="pi pi-database"
            (click)="populate()"
            [disabled]="loading"></button>
        </ng-template>
      </p-dialog>

      <p-dialog [(visible)]="showImportDialog"
        [header]="lang.el('Importa')"
        [modal]="true" [style]="{ width: '40rem' }"
        [draggable]="false" [resizable]="false">
        <p class="mb-3 text-color-secondary">
          {{ lang.el('CSV con colonne') }}:
          <code>id;src_table;des_comp_it;des_en;des_fr;des_de;des_es;des_nl;des_pt</code>.
          {{ lang.el('Chiave') }}: <code>src_table + des_comp_it</code>.
          {{ lang.el('Se la chiave esiste le traduzioni vengono sostituite.') }}
        </p>
        <div class="mb-3">
          <input type="file" accept=".csv,text/csv" (change)="onImportFileSelected($event)" />
        </div>
        <div *ngIf="importFileName">
          <div>{{ lang.el('File') }}: {{ importFileName }}</div>
          <div>{{ lang.el('Righe con traduzione') }}: {{ importPreviewCount }}</div>
        </div>
        <ng-template pTemplate="footer">
          <button pButton type="button" class="p-button-text"
            [label]="lang.el('Annulla')"
            (click)="showImportDialog = false"></button>
          <button pButton type="button"
            [label]="lang.el('Importa')"
            icon="pi pi-upload"
            (click)="confirmImport()"
            [disabled]="loading || !importRows.length"></button>
        </ng-template>
      </p-dialog>

      <div class="grid mb-3">
        <div class="col-12 md:col-3">
          <label>{{ lang.el('Filtro tabella') }}</label>
          <p-dropdown [options]="tableOptions" [(ngModel)]="filterTable"
            [showClear]="true" [filter]="true" placeholder="{{ lang.el('Tutte') }}"
            styleClass="w-full" (onChange)="load()"></p-dropdown>
        </div>
        <div class="col-12 md:col-3">
          <label>{{ lang.el('Ricerca') }}</label>
          <input pInputText class="w-full" [(ngModel)]="search"
            (keyup.enter)="load()" />
        </div>
        <div class="col-12 md:col-3 flex align-items-end gap-2">
          <div class="flex align-items-center mr-2">
            <p-checkbox [(ngModel)]="onlyMissing" [binary]="true" inputId="onlyMissing"
              (onChange)="load()"></p-checkbox>
            <label for="onlyMissing" class="ml-2">{{ lang.el('Solo mancanti') }}</label>
          </div>
          <button pButton type="button" class="p-button-outlined"
            [label]="lang.el('Aggiorna')" icon="pi pi-refresh"
            (click)="load()" [disabled]="loading"></button>
        </div>
      </div>

      <div class="grid mb-3 p-3 surface-100 border-round">
        <div class="col-12"><strong>{{ lang.el('Replace in lingua') }}</strong></div>
        <div class="col-12 md:col-3">
          <label>{{ lang.el('Lingua') }}</label>
          <p-dropdown [options]="languages" [(ngModel)]="replaceLang"
            optionLabel="label" optionValue="value"
            styleClass="w-full"></p-dropdown>
        </div>
        <div class="col-12 md:col-3">
          <label>{{ lang.el('Cerca') }}</label>
          <input pInputText class="w-full" [(ngModel)]="replaceFind" />
        </div>
        <div class="col-12 md:col-3">
          <label>{{ lang.el('Sostituisci con') }}</label>
          <input pInputText class="w-full" [(ngModel)]="replaceWith" />
        </div>
        <div class="col-12 md:col-3 flex align-items-end">
          <button pButton type="button" class="p-button-warning"
            [label]="lang.el('Esegui replace')"
            icon="pi pi-replay"
            (click)="confirmReplace()"
            [disabled]="loading"></button>
        </div>
        <div class="col-12 text-sm text-color-secondary">
          {{ lang.el('Il replace opera sulla lingua selezionata e, se impostato, sul filtro tabella.') }}
        </div>
      </div>

      <p-table [value]="rows" [paginator]="true" [rows]="20" [loading]="loading"
        [resizableColumns]="true" [scrollable]="true" scrollHeight="60vh"
        dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">ID</th>
            <th pResizableColumn style="min-width: 8rem">{{ lang.el('Tabella') }}</th>
            <th pResizableColumn style="min-width: 14rem">{{ lang.el('Descrizione IT') }}</th>
            <th *ngFor="let l of languages" pResizableColumn style="min-width: 12rem">{{ l.label }}</th>
            <th style="width: 4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.id }}</td>
            <td>{{ row.src_table }}</td>
            <td>{{ row.des_comp_it }}</td>
            <td *ngFor="let l of languages">
              <textarea pInputTextarea [(ngModel)]="row[l.column]" rows="2"
                class="w-full"></textarea>
            </td>
            <td>
              <button pButton type="button" icon="pi pi-save"
                class="p-button-rounded p-button-text"
                (click)="saveRow(row)"
                pTooltip="{{ lang.el('Salva') }}"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="4 + languages.length">{{ lang.el('Nessun risultato trovato') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
